enum AccountStatus {
  UNKNOWN = 'UNKNOWN',
  CREATED = 'CREATED',
  CONFIRMED = 'CONFIRMED',
  FREE = 'FREE',
  PAID = 'PAID',
}

export default AccountStatus
